export class Dataset {
    public label: string;
    public backgroundColor: string;
    public borderColor: string;
    public data: number[];
  }
  
  export default Dataset;                    